import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { CurrencyCode } from '@99designs/i18n';
import { PartnerContext, partnerFundedHeading, Price } from '@99designs/spa-common';
import InvoicePage from '../../common/components/InvoicePage';
import { StepType } from '../../util/step';
import BriefWizard from '../BriefWizard';
import { getPaymentSource } from '../PaymentSource';
import { StructuredBriefFragment } from './DynamicBrief.generated';
import { createSteps } from './Step';
import { Summary } from './Summary';
import React, { useContext } from 'react';

export function PurchaseProductBriefWizard({
    brief,
    formData,
    refetch,
    currentStep,
}: {
    brief: StructuredBriefFragment;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: Record<string, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    refetch: (options: { id: string }) => Promise<any>;
    currentStep: number;
}) {
    if (!brief.product) {
        throw new Error('Missing product');
    }

    const { partner } = useContext(PartnerContext);
    const noPaymentRequiredHeading = partnerFundedHeading(partner);

    return (
        <BriefWizard
            refetch={refetch}
            brief={brief}
            formData={formData}
            schema={brief.schemaId}
            disableContacts
            totalAllowableDesigners={1}
            briefProduct={brief.product}
            order={brief.order}
            jobId={brief.job?.id}
            postPaymentRedirect="job" // anything that comes through here is a job
            noPaymentRequiredHeading={noPaymentRequiredHeading}
            currentStep={currentStep}
            steps={createSteps(brief, [
                {
                    title: __('Review your brief'),
                    render: () => <Summary brief={brief} />,
                },
                {
                    title:
                        getPaymentSource(brief) === 'fully-funded'
                            ? __('Confirm details to start your project')
                            : __('Pay to kick off your project'),
                    stepType:
                        getPaymentSource(brief) === 'fully-funded'
                            ? undefined
                            : StepType.OrderPayment,
                    nextActionLabel:
                        getPaymentSource(brief) === 'fully-funded' ? (
                            __('Confirm')
                        ) : (
                            <FormattedMessage
                                message={__('Pay {price}')}
                                values={{
                                    price: (
                                        <Price
                                            amount={
                                                brief.product.pricing.amount.amountInCents +
                                                (brief.product.pricing.gst
                                                    ? brief.product.pricing.gst
                                                    : 0)
                                            }
                                            currency={
                                                brief.product.pricing.amount
                                                    .currency as CurrencyCode
                                            }
                                            minimumFractionDigits={2}
                                        />
                                    ),
                                }}
                            />
                        ),
                    isAuthRequired: true,
                    render: () => <InvoicePage brief={brief} />,
                },
            ])}
        />
    );
}
